import { render, staticRenderFns } from "./AdminUserNew.vue?vue&type=template&id=3472d02d&scoped=true&"
import script from "./AdminUserNew.vue?vue&type=script&lang=js&"
export * from "./AdminUserNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3472d02d",
  null
  
)

export default component.exports